var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCircle01 = function SvgAddCircle01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.98,
    y1: 138.37,
    x2: 161.78,
    y2: 47.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 54.64,
    y1: 137.97,
    x2: 161.44,
    y2: 46.94,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,0C44.86,0,0,44.86,0,100s44.86,100,100,100,100-44.86,100-100S155.14,0,100,0ZM100,184.51c-46.59,0-84.51-37.91-84.51-84.51S53.41,15.49,100,15.49s84.51,37.91,84.51,84.51-37.91,84.51-84.51,84.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.73,91.56h-30.98v-30.98c0-4.28-3.46-7.75-7.75-7.75s-7.75,3.47-7.75,7.75v30.98h-30.98c-4.28,0-7.75,3.47-7.75,7.75s3.46,7.75,7.75,7.75h30.98v30.98c0,4.28,3.46,7.75,7.75,7.75s7.75-3.47,7.75-7.75v-30.98h30.98c4.28,0,7.75-3.47,7.75-7.75s-3.46-7.75-7.75-7.75Z"
  })));
};
export default SvgAddCircle01;